<template>
  <aside class="admin-sidebar">
    <div class="brand-block">
      <span>DeRAS</span>
      <strong>后台管理系统</strong>
      <p>Admin Console</p>
    </div>

    <nav class="menu-block">
      <button
        v-for="item in menus"
        :key="item.name"
        type="button"
        :class="['menu-item', { active: activeName === item.name }]"
        @click="go(item.name)"
      >
        <span>{{ item.code }}</span>
        <div>
          <strong>{{ item.label }}</strong>
          <em>{{ item.desc }}</em>
        </div>
      </button>
    </nav>

    <div class="sidebar-footer">
      <button type="button" class="bigscreen-footer-btn" @click="openBigscreen">任务大屏</button>
      <button type="button" @click="go('home')">用户首页</button>
      <button type="button" @click="handleLogout">退出后台</button>
    </div>
  </aside>
</template>

<script>
import { logoutAdmin } from '../utils/auth'

export default {
  name: 'ComAsideAdmin',
  data() {
    return {
      menus: [
        { code: '01', name: 'adminTaskMarket', label: '任务审核市场', desc: 'DeRAS审核 / 人工复核' },
        { code: '02', name: 'robotMarket', label: '机器人市场', desc: '机器人状态 / 下架管理' },
        { code: '03', name: 'adminRevenue', label: '平台收入报表', desc: '手续费 / 交易流水' },
        { code: '04', name: 'adminOrders', label: '订单/交易管理', desc: '支付 / 退款 / 补扣 / 手续费' },
        { code: '05', name: 'adminSdkDevices', label: 'SDK设备管理', desc: 'TPM公钥 / 绑定 / 验签记录' },
        { code: '06', name: 'adminDerasReviews', label: 'DeRAS复核仲裁', desc: '异常复核 / 人工仲裁' },
        { code: '07', name: 'adminDispatch', label: '派单运维中心', desc: '候选队列 / 超时 / 手动派单' },
        { code: '08', name: 'adminExceptions', label: '异常处置中心', desc: '离线 / 停滞 / 仲裁 / 派单兜底' },
        { code: '09', name: 'adminUsers', label: '用户信息管理', desc: '用户资料 / 注销启用' },
        { code: '10', name: 'adminRobotArchives', label: '机器人档案库', desc: '档案资料 / 服务范围 / 设备状态' },
        { code: '11', name: 'adminOpenApiDoc', label: '第三方文档管理', desc: 'Open API 接入文档' }
      ]
    }
  },
  computed: {
    activeName() {
      return this.$route.name
    }
  },
  methods: {
    go(name) {
      if (this.$route.name === name) return
      this.$router.push({ name })
    },
    openBigscreen() {
      const url = process.env.VUE_APP_BIGSCREEN_URL || '/bigscreen/'
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    handleLogout() {
      logoutAdmin()
      this.$message.success('已退出管理员后台')
      this.$router.replace({ name: 'adminLogin' })
    }
  }
}
</script>

<style scoped>
.admin-sidebar {
  width: 260px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  color: #f6fbff;
  background:
    linear-gradient(180deg, rgba(4, 16, 29, 0.98), rgba(4, 10, 18, 0.98)),
    #05101d;
  border-right: 1px solid rgba(143, 241, 199, 0.14);
  box-shadow: 18px 0 45px rgba(0, 0, 0, 0.22);
}

.brand-block {
  padding: 18px 16px 20px;
  border-radius: 18px;
  background:
    linear-gradient(135deg, rgba(143, 241, 199, 0.14), rgba(255, 208, 138, 0.08)),
    rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(143, 241, 199, 0.16);
}

.brand-block span {
  display: inline-flex;
  margin-bottom: 12px;
  padding: 5px 9px;
  border-radius: 999px;
  color: #03101d;
  background: #8ff1c7;
  font-size: 12px;
  font-weight: 900;
}

.brand-block strong,
.brand-block p {
  display: block;
  margin: 0;
}

.brand-block strong {
  font-size: 20px;
}

.brand-block p {
  margin-top: 6px;
  color: rgba(246, 251, 255, 0.58);
  font-size: 12px;
  letter-spacing: 0.14em;
}

.menu-block {
  display: grid;
  gap: 10px;
  margin-top: 20px;
}

.menu-item {
  width: 100%;
  min-height: 68px;
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 12px;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 12px;
  color: rgba(246, 251, 255, 0.78);
  text-align: left;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.045);
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.menu-item:hover,
.menu-item.active {
  transform: translateX(3px);
  color: #fff;
  border-color: rgba(143, 241, 199, 0.36);
  background: linear-gradient(135deg, rgba(143, 241, 199, 0.15), rgba(142, 215, 255, 0.08));
}

.menu-item span {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #03101d;
  background: rgba(143, 241, 199, 0.88);
  font-weight: 900;
  font-size: 12px;
}

.menu-item strong,
.menu-item em {
  display: block;
  font-style: normal;
}

.menu-item strong {
  font-size: 14px;
}

.menu-item em {
  margin-top: 5px;
  color: rgba(246, 251, 255, 0.5);
  font-size: 12px;
}

.sidebar-footer {
  display: grid;
  gap: 10px;
  margin-top: auto;
  padding-top: 18px;
}

.sidebar-footer button {
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  color: rgba(246, 251, 255, 0.8);
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-footer .bigscreen-footer-btn {
  color: #03101d;
  border-color: transparent;
  background: linear-gradient(135deg, #8ff1c7, #8ed7ff);
  font-weight: 900;
}
</style>
